import { Component } from '@theme/component';

/**
 * @typedef {object} Refs
 * @property {HTMLElement} track
 * @property {HTMLButtonElement} [previous]
 * @property {HTMLButtonElement} [next]
 */

/** @extends {Component<Refs>} */
class BlockCarousel extends Component {
  requiredRefs = ['track'];

  connectedCallback() {
    super.connectedCallback();
    this.#updateArrows();
    this.refs.track.addEventListener('scroll', () => this.#updateArrows(), { passive: true });
  }

  previous() {
    this.#scrollBy(-1);
  }

  next() {
    this.#scrollBy(1);
  }

  #scrollBy(direction) {
    const track = this.refs.track;
    const firstSlide = track.firstElementChild;
    if (!firstSlide) return;
    const slideWidth = firstSlide.getBoundingClientRect().width;
    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    track.scrollBy({ left: direction * (slideWidth + gap), behavior: 'smooth' });
  }

  #updateArrows() {
    const track = this.refs.track;
    const atStart = track.scrollLeft <= 2;
    const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;

    if (this.refs.previous) {
      this.refs.previous.disabled = atStart;
      this.refs.previous.setAttribute('aria-disabled', String(atStart));
    }
    if (this.refs.next) {
      this.refs.next.disabled = atEnd;
      this.refs.next.setAttribute('aria-disabled', String(atEnd));
    }
  }
}

if (!customElements.get('block-carousel')) {
  customElements.define('block-carousel', BlockCarousel);
}
